export default {
  "sub-container": "_sub-container_ijw642",
  "organization-container": "_organization-container_ijw642",
  "organization-container-focus": "_organization-container-focus_ijw642"
};
